import {createUseStyles} from "react-jss";

const useStyles = createUseStyles({
    error:{
        padding: 5,
        background: 'var(--bs-danger)',
        color: 'var(--bs-gray-100)',
        borderRadius: 5,
        border: '1px solid var(--bs-red)',
        marginTop:1,
    }
});
const Error = ({children})=>{
    const classes = useStyles();
    if(!children)return void 0;
    return <div className={classes.error}>{children}</div>
}
export default Error;
